import { AutoComplete } from 'antd'

const AntAutoCompleteStyled = AutoComplete
export default AntAutoCompleteStyled
